<mat-card *ngIf="config" [class]="'gb-alert-box ' + config.cssClass">
  <div class="flex-row px-gap-16 flex-justify-start flex-align-center">
    <div *ngIf="config.icon || config.showLoader" class="flex-col">
      <ng-container *ngIf="config.showLoader; else showIcon">
        <mat-spinner class="alert-spinner" diameter="35"></mat-spinner>
      </ng-container>
      <ng-template #showIcon>
        <mat-icon>
          {{ config.icon }}
        </mat-icon>
      </ng-template>
    </div>
    <div class="flex-col">
      <h2 *ngIf="config.heading" [translate]="config.heading"></h2>
      <p *ngIf="config.message">
        {{ config.message | translate }}
        <span *ngIf="config.link" (click)="config.link.onClick()" class="link">
          {{ config.link.message | translate }}
        </span>
      </p>
    </div>
  </div>
</mat-card>
